import React from 'react';
import {Link} from 'react-router-dom';


// Small "go back" arrow used in a contentWindow__header, next to the
// section title, on pages nested one level below a picker/list page
// (e.g. admin/users and admin/pdf below the admin section picker).
const BackButton = (props: { to: string, label?: string }) => {
    const label = props.label ?? 'Назад';

    return (
        <Link to={props.to} className='backButton' aria-label={label} title={label}>
            <svg width={16} height={16} viewBox="0 0 24 24" fill="none" stroke="currentColor"
                 strokeWidth={2} strokeLinecap="round" strokeLinejoin="round">
                <path d="M15 6l-6 6 6 6"/>
            </svg>
        </Link>
    );
};

export default BackButton;
